module.exports = __webpack_public_path__ + "static/media/RotateLeft.6204a8ae.svg";